import { CustomerSettingType, CustomerSetting } from '../models/customer-setting';
class CustomerSettings {
    private static _instance: CustomerSettings = new CustomerSettings();
    constructor() {
        if (CustomerSettings._instance) {
            throw new Error('Singleton class');
        }
        CustomerSettings._instance = this;
    }

    public static get instance(): CustomerSettings {
        return CustomerSettings._instance;
    }

    getCustomerSetting(customerSettings: CustomerSetting[], name: string): any {
        const setting = customerSettings?.find((theSetting) => {
            return theSetting.name === name;
        });

        // Should only occur if customer settings couldn't be loaded. For example if logged in a super admin.
        if (!setting) {
            return;
        }

        switch (setting.type) {
            case CustomerSettingType.Object: {
                try {
                    return JSON.parse(setting.value as string);
                } catch (err) {
                    return setting.value;
                }
            }
            case CustomerSettingType.Boolean:
                return setting.value === 'true' || setting.value === true;
            default:
                return setting.value;
        }
    }
}

export const customerSettings = CustomerSettings.instance;
